import { GlobalAxios } from "../axios/axios-config";
import { IResSendNonLabWorklistZLog } from "../models/res-send-non-lab-worklist-z-log";

const RES_SEND_NON_LAB_WORKLIST_Z_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ResSendNonLabWorklistZ/ResSendNonLabWorklistZLog";

export const getResSendNonLabWorklistZLog = (resSendIdentifier: number) => {
  return GlobalAxios.get<IResSendNonLabWorklistZLog>(
    RES_SEND_NON_LAB_WORKLIST_Z_LOG_ROUTE,
    {
      params: {
        resSendIdentifier,
      },
    },
  );
};
